import React from "react";
import { Panel } from "@xyflow/react";
import { Badge, Button, XClose } from "@opendate-app/setlist";

import { useCustomCampaignShowContext } from "../CustomCampaignShowContainer";
import { NODE_ICONS } from "./nodeIcons";

const sidebarStyle = {
  minWidth: 300,
  padding: 20,
  width: "fit-content",
  height: "fit-content",
  backgroundColor: "var(--sl-bg-primary)",
  marginRight: 8,
  borderRadius: 12,
  border: "1px solid var(--sl-border-secondary)",
  boxShadow: "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  color: "var(--sl-text-primary)",
};

const headerStyle = {
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  width: "100%",
  marginBottom: 16,
};

const titleStyle = {
  fontSize: 18,
  fontWeight: 600,
  lineHeight: "28px",
};

const draggableRowStyle = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: 8,
  padding: "4px 12px",
  width: "100%",
  borderRadius: 4,
  border: "1px solid var(--sl-border-primary)",
  boxShadow: "0px 1px 2px 0px rgba(10, 13, 18, 0.05)",
  cursor: "grab",
  marginTop: 4,
  backgroundColor: "var(--sl-bg-primary)",
  color: "var(--sl-text-secondary)",
  fontSize: 14,
  fontWeight: 600,
  lineHeight: "20px",
  transform: "translate(0, 0)",
};

const SECTIONS = [
  {
    label: "Messages",
    color: "blue",
    nodes: [
      { type: "WorkflowNodes::EmailNode", label: "Email" },
      { type: "WorkflowNodes::SmsNode", label: "SMS" },
    ],
  },
  {
    label: "Delays",
    color: "warning",
    nodes: [
      { type: "WorkflowNodes::WaitUntilNode", label: "Wait until..." },
      { type: "WorkflowNodes::TimeDelayNode", label: "Time delay" },
      { type: "WorkflowNodes::SendBetweenNode", label: "Send between" },
    ],
  },
  {
    label: "Flow Control",
    color: "purple",
    nodes: [
      { type: "WorkflowNodes::TrueFalseBranchNode", label: "True/False Branch" },
    ],
  },
];

export default () => {
  const { setBuildPayload, setBuilding } = useCustomCampaignShowContext();

  const onDragStart = (event, nodeType) => {
    setBuildPayload(nodeType);
    event.dataTransfer.effectAllowed = "move";
  };

  return (
    <Panel position="top-right">
      <div style={sidebarStyle}>
        <div style={headerStyle}>
          <div style={titleStyle}>Build</div>
          <Button variant="tertiary" size="sm" icon={XClose} aria-label="Close" onClick={() => setBuilding(false)} />
        </div>
        {SECTIONS.map((section) => (
          <React.Fragment key={section.label}>
            <div style={{ marginTop: 8 }}>
              <Badge type="badge-color" color={section.color} size="sm">{section.label}</Badge>
            </div>
            {section.nodes.map((node) => {
              const NodeIcon = NODE_ICONS[node.type];
              return (
                <div
                  key={node.type}
                  draggable
                  onDragStart={(event) => onDragStart(event, { type: node.type })}
                  style={draggableRowStyle}
                >
                  <NodeIcon width={16} height={16} aria-hidden="true" style={{ color: "var(--sl-fg-quaternary)" }} />
                  {node.label}
                </div>
              );
            })}
          </React.Fragment>
        ))}
      </div>
    </Panel>
  );
};
